<div
    [formGroup]="form"
>
    <div class="mb-2">
        <strong>List:</strong> {{ externalDataSource.label }}
    </div>
    <label for="customListExternalDataAttribute">Attribute</label>
    <select
        class="form-control"
        formControlName="customListExternalDataAttribute"
        name="customListExternalDataAttribute"
        id="customListExternalDataAttribute"
        (change)="handleChanges()"
        [(ngModel)]="sourceConfig.selectedOption"
    >
        <option [ngValue]="null">-- Select Attribute --</option>
        <option
            *ngFor="let option of sourceConfig.options"
            [ngValue]="option"
        >
            {{ option.attributeName }}
        </option>
    </select>
</div>
